import {waitForPolaris} from './utils/polarisRuntime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
waitForPolaris().then(() => root.render(
  <>
    <App />
  </>,
)).catch(() => root.render(<div role="alert"><p>Unable to load Shopify components. Reload the app.</p><button onClick={() => window.location.reload()}>Retry</button></div>));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
